export default "__VITE_ASSET__71ab0ad1__"